var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47012 18.0002H17.5301C19.0701 18.0002 20.0301 16.3302 19.2601 15.0002L11.7301 1.99018C10.9601 0.660176 9.04012 0.660176 8.27012 1.99018L0.740121 15.0002C-0.0298788 16.3302 0.930121 18.0002 2.47012 18.0002ZM10.0001 11.0002C9.45012 11.0002 9.00012 10.5502 9.00012 10.0002V8.00018C9.00012 7.45018 9.45012 7.00018 10.0001 7.00018C10.5501 7.00018 11.0001 7.45018 11.0001 8.00018V10.0002C11.0001 10.5502 10.5501 11.0002 10.0001 11.0002ZM11.0001 15.0002H9.00012V13.0002H11.0001V15.0002Z",
    fill: "#BBA88C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRounded);
export default __webpack_public_path__ + "static/media/warning-rounded.c4eed1c48f7242a59451c12e7160eeff.svg";
export { ForwardRef as ReactComponent };